<script setup>
import CardLabel from '@/Components/Card/CardLabel.vue';
import Card from '@/Components/Card/Card.vue';
import { ToggleTracker } from '@/Common/utils.js';
import IconExpandCircleDown from '@/Components/Icons/IconExpandCircleDown.vue';
import PropertyListItem from '@/Pages/HeaderAnalysis/Partials/PropertyListItem.vue';
import { mapAntispamHeader } from '@/Common/Classifiers/AntispamHeaderTagMapper.js';

defineProps({
  antispamHeaders: Array
});

const toggler = new ToggleTracker();
</script>

<template>
  <div>
    <CardLabel
      :label="$t('header_analysis.partials.antispam_headers.antispam_headers')"
    />
    <Card>
      <div v-if="0 === antispamHeaders.length">
        {{ $t('header_analysis.partials.antispam_headers.no_results') }}
      </div>
      <div v-else class="flex flex-col gap-2">
        <div class="flex gap-6">
          <div class="w-1/6 font-bold">
            {{ $t('header_analysis.partials.antispam_headers.field') }}
          </div>
          <div class="w-1/3 font-bold">
            {{ $t('header_analysis.partials.antispam_headers.value') }}
          </div>
          <div class="w-1/3 font-bold">
            {{ $t('header_analysis.partials.antispam_headers.description') }}
          </div>
          <div class="w-1/12 font-bold"><!-- action col --></div>
        </div>
        <template v-for="(header, index) in antispamHeaders" :key="index">
          <div
            class="flex cursor-pointer items-center gap-6"
            @click="toggler.toggle(index)"
          >
            <div class="w-1/6">{{ header.field }}</div>
            <div class="w-1/3 truncate">{{ header.value }}</div>
            <div class="w-1/3 grow">
              {{ mapAntispamHeader(header.field, header.value).description }}
            </div>
            <div class="flex w-1/12 justify-end">
              <IconExpandCircleDown
                class="text-navy-200 self-end transition-transform duration-300"
                :class="{ '-rotate-180': toggler.isToggled(index) }"
              />
            </div>
          </div>
          <Card
            v-if="toggler.isToggled(index)"
            class="bg-white-500!"
            :pad-bottom="true"
          >
            <div class="flex w-1/2 flex-col">
              <PropertyListItem
                :title="$t('header_analysis.partials.antispam_headers.field')"
                :value="header.field"
              />
              <PropertyListItem
                :title="$t('header_analysis.partials.antispam_headers.value')"
                :value="header.value"
              />
              <PropertyListItem
                :title="
                  $t('header_analysis.partials.antispam_headers.description')
                "
                :value="
                  mapAntispamHeader(header.field, header.value).description
                "
              />
              <PropertyListItem
                v-if="header.explanation"
                :title="
                  $t('header_analysis.partials.antispam_headers.explanation')
                "
                :value="
                  mapAntispamHeader(header.field, header.value).explanation
                "
              />
            </div>
          </Card>
        </template>
      </div>
    </Card>
  </div>
</template>
